<template>
  <nav class="navbar navbar-toggleable-md navbar-inverse bg-primary fixed-top">
    <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbar-dropdown" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <a class="navbar-brand ml-5" href="#"></a>
    <div class="collapse navbar-collapse" id="navbar-dropdown">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <a class="nav-link" href="#">Strona Główna</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Oferta Indywidualna</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Oferta Biznesowa</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Kontakt</a>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script>
export default {
  name: 'main-navbar',
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// MainNavbar.vue?66084b13